/* eslint-disable import/no-cycle */
import { call, put, takeEvery } from 'redux-saga/effects';
import { receptions } from '../../api/api';
import {
  GET_RECEPTIONS,
  GET_RECEPTIONS_SUCCESS,
  GET_RECEPTIONS_FAILURE,
  GET_RECEPTION,
  GET_RECEPTION_SUCCESS,
  GET_RECEPTION_FAILURE,
  EXPORT_RECEPTION,
  EXPORT_RECEPTION_SUCCESS,
  EXPORT_RECEPTION_FAILURE
} from './receptionsActions';

import logger from '../../utils/logger';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';

function downloadBase64File(contentType, base64Data, fileName) {
  const linkSource = `data:${contentType};base64,${base64Data}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

/**
 * Export du compatif de la réception
 * @param  {Object} action action object
 */
export function* exportReception(action) {
  const closeLoading = displayLoading('Préparation de votre fichier en cours');
  try {
    const response = yield call(
      receptions.exportReceptionComparative,
      action.payload
    );
    if (response.data.success === true) {
      yield put({ type: EXPORT_RECEPTION_SUCCESS, payload: response.data });
      downloadBase64File(
        'application/octet-stream',
        response.data.base64ExcelComparative,
        'comparative.xlsx'
      );
      closeLoading();
      displaySuccess('Fichier téléchargé avec succès');
    } else {
      closeLoading();
    }
  } catch (error) {
    logger(error);
    yield put({ type: EXPORT_RECEPTION_FAILURE });
  }
}

/**
 * Récupération de plusieurs receptions
 * @param  {Object} action action object
 */
export function* getReceptions(action) {
  try {
    const response = yield call(receptions.getReceptions, action.payload);
    if (response.data.success === true) {
      yield put({ type: GET_RECEPTIONS_SUCCESS, payload: response.data });
    } else {
      yield put({ type: GET_RECEPTIONS_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_RECEPTIONS_FAILURE });
  }
}

/**
 * Récupération du détail d'une réception
 * @param  {Object} action action object
 */
export function* getReception(action) {
  try {
    const response = yield call(receptions.getReception, action.payload);
    if (response.data.success === true) {
      yield put({ type: GET_RECEPTION_SUCCESS, payload: response.data });
    } else {
      yield put({ type: GET_RECEPTION_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_RECEPTION_FAILURE });
  }
}

const signinSaga = [
  takeEvery(GET_RECEPTIONS, getReceptions),
  takeEvery(GET_RECEPTION, getReception),
  takeEvery(EXPORT_RECEPTION, exportReception)
];

export default signinSaga;
